<div class="switch-container" *ngIf="isNLSearchEnabled">
  <lo-button [variant]="'action'" [label] = "'Filter Search'" (onClick)="showFilter()" [ngClass]="isFilterClicked? 'active' : ''"></lo-button>

  <lo-button [variant]="'action'" [label] = "'Natural Language Search (Beta)'" (onClick)="showFilter()"  [ngClass]="!isFilterClicked? 'active' : ''" [icon]="'nls'"></lo-button>
</div>


<app-search-start-v2 *ngIf="isFilterClicked" [isNLSearchEnabled]="isNLSearchEnabled" ></app-search-start-v2>

<app-carefindr-ai  *ngIf="!isFilterClicked"></app-carefindr-ai>
